<template>
    <footer class="bg-black white">
        <div class="container mt4">

            <div class="row">
                <!-- logo -->
                <div class="col-xs-12">
                    <img class="row pv3" src="@/assets/img/logos/tooliaba_logo_footer.svg"/>
                </div>
            </div>

            <div class="row">
                <!-- connect with us -->
                <div class="col-xs-12 col-md-6">
                    <Connect class="pv3" />
                </div>

                <!-- newsletter -->
                <div class="col-xs-12 col-md-4 col-md-offset-2">
                    <Newsletter class="pv3" />
                </div>
            </div>

            <div class="row">
                <!-- links -->
                <div class="col-xs-12">
                    <Links class="pv3"/>
                </div>
            </div>

        </div>
    </footer>
</template>

<script>
import TooliabaButton from '@/components/buttons/TooliabaButton.vue';
import MailTo from '@/components/global/MailTo.vue';
import Connect from '@/components/footer/connect/Connect.vue';
import Newsletter from '@/components/footer/Newsletter.vue';
import Links from '@/components/footer/links/Links.vue';

export default {
    components: {
        TooliabaButton,
        MailTo,
        Connect,
        Newsletter,
        Links
    }
};
</script>
